/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("BorrowerProfileWithTabs", ["jquery", "Behaviors"], factory);
    } else {
        root.BorrowerProfileWithTabs = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    var moduleInstanceId;

    function BorrowerProfileWithTabs(target) {
       
        //handle multiple instances in one page

        this.moduleInstanceId = '.fl-node-' + target.getAttribute( 'data-BorrowerProfileWithTabs' );

        Behaviors.init(BorrowerProfileWithTabs, this, arguments);

        this.element = this.$elem[0];

        $( BorrowerProfileWithTabs.ELEMENTS.BorrowerProfileWithTabsItem ).click( function(){

            //grab target
            var target = $(this).data('target');

            console.log('clicked');

            console.log( target );

            $(BorrowerProfileWithTabs.ELEMENTS.BorrowerProfileWithTabsItem ).each( function() {

              
                // toggle visiblity of other tab containers

                if( target != $(this).data('target') ){
                    $(this).removeClass('active');
                    $( '#' + $(this).data('target') ).removeClass('active');
                }else{
                    $(this).addClass('active');
                    $( '#' + $(this).data('target') ).addClass('active');
                }

            });

           
        });



    }

    Behaviors.inherit(BorrowerProfileWithTabs, Behaviors.Behavior);

    BorrowerProfileWithTabs.QUERY = "[data-BorrowerProfileWithTabs]";

    BorrowerProfileWithTabs.ELEMENTS = {
        BorrowerProfileWithTabsItem: ".tab-span",
    };

    
    Behaviors.register_behavior(BorrowerProfileWithTabs);

    module.BorrowerProfileWithTabs = BorrowerProfileWithTabs;

    return module;
}));
